import { render, staticRenderFns } from "./basePlanInfo.vue?vue&type=template&id=23de8167&scoped=true&"
import script from "./basePlanInfo.vue?vue&type=script&lang=js&"
export * from "./basePlanInfo.vue?vue&type=script&lang=js&"
import style0 from "./basePlanInfo.vue?vue&type=style&index=0&id=23de8167&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de8167",
  null
  
)

export default component.exports